/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.9
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateVendorOutputDTO } from '../model';
// @ts-ignore
import { CreateVendorRequest } from '../model';
// @ts-ignore
import { GetVendorsOutputDTO } from '../model';
// @ts-ignore
import { HTTPValidationError } from '../model';
// @ts-ignore
import { UpdateVendorOutputDTO } from '../model';
// @ts-ignore
import { UpdateVendorRequest } from '../model';
/**
 * VendorApi - axios parameter creator
 * @export
 */
export const VendorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Vendor
         * @param {CreateVendorRequest} createVendorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorDockschedulingVendorsPost: async (createVendorRequest: CreateVendorRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createVendorRequest' is not null or undefined
            assertParamExists('createVendorDockschedulingVendorsPost', 'createVendorRequest', createVendorRequest)
            const localVarPath = `/dockscheduling/vendors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVendorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Vendor
         * @param {string} vendorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorDockschedulingVendorsVendorIdDelete: async (vendorId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('deleteVendorDockschedulingVendorsVendorIdDelete', 'vendorId', vendorId)
            const localVarPath = `/dockscheduling/vendors/{vendor_id}`
                .replace(`{${"vendor_id"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Vendors
         * @param {string | null} [id]
         * @param {string | null} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorsDockschedulingVendorsGet: async (id?: string | null, name?: string | null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dockscheduling/vendors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Vendor
         * @param {string} vendorId
         * @param {UpdateVendorRequest} updateVendorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendorDockschedulingVendorsVendorIdPut: async (vendorId: string, updateVendorRequest: UpdateVendorRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('updateVendorDockschedulingVendorsVendorIdPut', 'vendorId', vendorId)
            // verify required parameter 'updateVendorRequest' is not null or undefined
            assertParamExists('updateVendorDockschedulingVendorsVendorIdPut', 'updateVendorRequest', updateVendorRequest)
            const localVarPath = `/dockscheduling/vendors/{vendor_id}`
                .replace(`{${"vendor_id"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVendorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendorApi - functional programming interface
 * @export
 */
export const VendorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendorApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Vendor
         * @param {CreateVendorRequest} createVendorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVendorDockschedulingVendorsPost(createVendorRequest: CreateVendorRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateVendorOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVendorDockschedulingVendorsPost(createVendorRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Vendor
         * @param {string} vendorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVendorDockschedulingVendorsVendorIdDelete(vendorId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVendorDockschedulingVendorsVendorIdDelete(vendorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Vendors
         * @param {string | null} [id]
         * @param {string | null} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorsDockschedulingVendorsGet(id?: string | null, name?: string | null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVendorsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorsDockschedulingVendorsGet(id, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update Vendor
         * @param {string} vendorId
         * @param {UpdateVendorRequest} updateVendorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVendorDockschedulingVendorsVendorIdPut(vendorId: string, updateVendorRequest: UpdateVendorRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateVendorOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVendorDockschedulingVendorsVendorIdPut(vendorId, updateVendorRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VendorApi - factory interface
 * @export
 */
export const VendorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendorApiFp(configuration)
    return {
        /**
         *
         * @summary Create Vendor
         * @param {CreateVendorRequest} createVendorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorDockschedulingVendorsPost(createVendorRequest: CreateVendorRequest, options?: any): AxiosPromise<CreateVendorOutputDTO> {
            return localVarFp.createVendorDockschedulingVendorsPost(createVendorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Vendor
         * @param {string} vendorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorDockschedulingVendorsVendorIdDelete(vendorId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteVendorDockschedulingVendorsVendorIdDelete(vendorId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Vendors
         * @param {string | null} [id]
         * @param {string | null} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorsDockschedulingVendorsGet(id?: string | null, name?: string | null, options?: any): AxiosPromise<GetVendorsOutputDTO> {
            return localVarFp.getVendorsDockschedulingVendorsGet(id, name, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Vendor
         * @param {string} vendorId
         * @param {UpdateVendorRequest} updateVendorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendorDockschedulingVendorsVendorIdPut(vendorId: string, updateVendorRequest: UpdateVendorRequest, options?: any): AxiosPromise<UpdateVendorOutputDTO> {
            return localVarFp.updateVendorDockschedulingVendorsVendorIdPut(vendorId, updateVendorRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VendorApi - object-oriented interface
 * @export
 * @class VendorApi
 * @extends {BaseAPI}
 */
export class VendorApi extends BaseAPI {
    /**
     *
     * @summary Create Vendor
     * @param {CreateVendorRequest} createVendorRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApi
     */
    public createVendorDockschedulingVendorsPost(createVendorRequest: CreateVendorRequest, options?: any) {
        return VendorApiFp(this.configuration).createVendorDockschedulingVendorsPost(createVendorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Vendor
     * @param {string} vendorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApi
     */
    public deleteVendorDockschedulingVendorsVendorIdDelete(vendorId: string, options?: any) {
        return VendorApiFp(this.configuration).deleteVendorDockschedulingVendorsVendorIdDelete(vendorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Vendors
     * @param {string | null} [id]
     * @param {string | null} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApi
     */
    public getVendorsDockschedulingVendorsGet(id?: string | null, name?: string | null, options?: any) {
        return VendorApiFp(this.configuration).getVendorsDockschedulingVendorsGet(id, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Vendor
     * @param {string} vendorId
     * @param {UpdateVendorRequest} updateVendorRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApi
     */
    public updateVendorDockschedulingVendorsVendorIdPut(vendorId: string, updateVendorRequest: UpdateVendorRequest, options?: any) {
        return VendorApiFp(this.configuration).updateVendorDockschedulingVendorsVendorIdPut(vendorId, updateVendorRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
